import { z } from 'zod';

export const downloadActivationCodesSchema = z.object({
  clientId: z.string().min(1, '利用企業を選択してください。'),
});

export type DownloadActivationCodesFormFieldValues = z.infer<typeof downloadActivationCodesSchema>;
